import * as React from "react";

export interface PartnerImageProps {
  src: string;
}

const PartnerImage = (props: PartnerImageProps) => (
  <div className="col-md-2 col-xs-6">
    <div style={{ display: "flex", alignItems: "center", height: 160 }}>
      <img src={props.src} className="img-responsive" />
    </div>
  </div>
);

export default PartnerImage;



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/components/PartnerImage.tsx